<label class="checkbox-toggle" [class.as-full]="fullSize" [for]="'tggl_' + name" tabindex="0" (keydown.space)="onKeyDownEvent($event)">
    <input type="checkbox" [id]="'tggl_' + name" class="toggle" (change)="updateModel($event)" [value]="value" [name]="name" [required]="required" [checked]="isChecked">
    <span class="slider"></span>
    <span *ngIf="currentLabel" class="as-label" [innerHTML]="currentLabel | translate"></span>
</label>
